module.exports = __webpack_public_path__ + "static/assets/2e922f402493514b5c7156a32ffda6cf.svg";